<template>
  <div class="content-tab poeschedule">
    <div class="content-body">
    <loading :mask=true :size="'big'" :isWhite=true v-if="isShowLoading"/>
      <div class="content-item">
        <div class="content-item title">
          <div class="port">
            {{$t('vlan.ports')}}
            <div v-for="num in portNumber" :key="num" class="port-cell" :class="{ selected: selectPort === num }" @click="onChangePort(num)" >{{num}}</div>
          </div>
        </div>
        <div class="group-table">
          <fixed-table class="poe-schedule-table" ref="poeScheduleTable" :data="portLists" :use-page="false" :header-height="30">
            <div class="right-header" slot="right-header">
                <column style="width: 5%;"/>
                <column class="timeline" style="width: 12%;" v-for="item in dstWeek" :key="item.value">{{$t(item.label)}}</column>
                <column style="width: 11%;"/>
            </div>
          </fixed-table>
        </div>
      </div>
      <scrollbar ref="scrollbar" class="scrollbar-body">
      <div class="content-item">
        <div class="group-table">
          <fixed-table class="poe-schedule-table" ref="poeScheduleTable" :data="portLists" :use-page="false" :header-height="30">
            <!-- <div class="right-header" slot="right-header">
                <column style="width: 5%;"/>
                <column class="timeline" style="width: 12%;" v-for="item in dstWeek" :key="item.value">{{$t(item.label)}}</column>
                <column style="width: 11%;"/>
            </div> -->
            <template slot="rows" slot-scope="props">
              <div class="link-row" :class="getPortName(props.data.key)" @click="onColClick(props.data.key)">
                <row class="right" :props="props" :title="getTips(props.data.key)">
                  <div class="data name" style="width: 5%;">
                    <div class="title">{{$t('port.portnumber')}}</div>
                    <div>{{getPortName(props.data.key)}}</div>
                  </div>
                  <div class="data timeline" style="width: 12%;" v-for="item in dstWeek" :key="item.value">
                    <div class="detail" v-if="props.data.val.Schedule == null" style="display: none;"> </div>
                    <div class="data timeline" v-else v-for="(data, index) in props.data.val.Schedule" :key="index">
                      <div class="detail"  v-if="item.value == parseInt(data.Week)" v-for="(time, index) in data.Time" :key="index" :title="getTime(time, true)">{{getTime(time, false)}}</div>
                    </div>
                  </div>
                  <div class="data" style="width: 11%;">
                    <toggle :title="'Schedule enable/ disabled'" :on="getToggle(props.index, props.data.key)" @click.native="onSwitchBtn(props.index, props.data.key)" :disabled="setDisabled(props.data.key)"></toggle>
                    <span class="icon-edit" @click="onEditClick(props)" :disabled="setDisabled(props.data.key)" :title="$t('edit')"></span>
                  </div>
                </row>
              </div>
            </template>
          </fixed-table>
        </div>
      </div>
      </scrollbar>
      <div class="content-body-footer">
        <button class="q-button blue-btn-full right" :title="$t('save')" @click="onSaveClick()" :disabled="!isButtonEnable">{{$t('save')}}</button>
      </div>
    </div>
    <PoeScheduleItem :selectItem="selectObject" :isEnable="selectEnable" :onChange="getConfig"></PoeScheduleItem>
    <v-dialog/>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from 'vuex'
import config from '../config'
import fixedTable from './table/FixedTable'
import row from './table/row/Row'
import column from './table/column/Column'
import toggle from './module/Toggle'
import PoeScheduleItem from './PoeScheduleItem'
export default {
  name: 'PoeConfiguration',
  components: {
    config,
    fixedTable,
    row,
    column,
    toggle,
    PoeScheduleItem
  },
  data () {
    return {
      isShowLoading: false,
      isButtonEnable: false,
      portLists: [],
      originalList: [],
      enableLists: [],
      originalEnableLists: [],
      selectPort: 1,
      preSelectPort: null,
      selectObject: null,
      selectEnable: null,
      dstWeek: [
        {label: 'dstWeek.mon', value: 1},
        {label: 'dstWeek.tue', value: 2},
        {label: 'dstWeek.wed', value: 3},
        {label: 'dstWeek.thu', value: 4},
        {label: 'dstWeek.fri', value: 5},
        {label: 'dstWeek.sat', value: 6},
        {label: 'dstWeek.sun', value: 0}
      ]
    }
  },
  created: async function () {
    this.getConfig()
  },
  updated () {
    let el = this.$getElementsByClassName(this.$el, this.selectPort)[0]
    let preEl = this.$getElementsByClassName(this.$el, this.preSelectPort)[0]
    if (el) {
      let element = el.children[0]
      element.style.background = '#FCFDD2'
      if (preEl && el !== preEl) {
        preEl.children[0].style.background = 'none'
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.isDataChanged) {
      next(false)
    } else {
      next()
    }
  },
  watch: {
    isButtonEnable: function (value) {
      this.$store.commit('updateDataChanged', value)
    }
  },
  methods: {
    getConfig: function () {
      this.isButtonEnable = false
      this.getPoeSchedule()
        .then((res) => {
          if (!res.data.error) {
            this.originalList = JSON.parse(JSON.stringify(res.data.result))
            this.portLists = res.data.result
            this.enableLists = res.data.result
            this.originalEnableLists = JSON.parse(JSON.stringify(res.data.result))
          }
          this.$log.debug(this.portLists)
          this.isShowLoading = false
        }).catch((err) => {
          this.$log.error(err)
          this.isShowLoading = false
        })
    },
    getPortName: function (item) {
      if (item) {
        return item
      }
    },
    getTime: function (data, isTooltops) {
      let time = data.split('-')
      let result = ''
      let start = parseInt(time[0])
      let end = parseInt(time[1])
      let startAmpm = (start > 11) ? ' pm' : ' am'
      let endAmpm = (end > 12) ? ' pm' : ' am'
      if (start === 0) {
        start = '00'
      } else if (start < 10) {
        start = '0' + start
      }
      if (end < 10) {
        end = '0' + end
      }
      if (isTooltops) {
        result = start + startAmpm + ' - ' + end + endAmpm
      } else {
        result = start + ' - ' + end
      }
      return result
    },
    getToggle: function (index, port) {
      if (this.enableLists.length > 0) {
        let item = this.enableLists[index]
        if (item.key === port) {
          return this.enableLists[index].val.Enable
        }
      } else {
        return false
      }
    },
    onSwitchBtn: function (index, port) {
      let item = this.enableLists[index]
      let isEnable = item.val.Enable
      this.enableLists[index].val.Enable = !isEnable
      this.portLists[index].val.Enable = !isEnable
      this.isButtonEnable = !(this.$compareObj(this.enableLists, this.originalEnableLists))
    },
    onChangePort: function (portNum) {
      let number = parseInt(portNum)
      let el = this.$getElementsByClassName(this.$el, number)[0]
      this.preSelectPort = this.selectPort
      this.selectPort = number
      this.$refs.scrollbar.scrollTo(el)
      // this.$refs.poeScheduleTable.$refs.scrollbar.scrollTo(el)
    },
    onColClick: function (data) {
      let number = parseInt(this.getPortName(data))
      this.preSelectPort = this.selectPort
      this.selectPort = number
    },
    onEditClick: function (element) {
      this.selectEnable = this.getToggle(element.index, element.data.key)
      this.selectObject = {data: element.data, isEnable: this.selectEnable}
      this.$modal.show('poe-schedule-modal')
      this.openModal('poe-schedule-modal')
    },
    onSaveClick: function () {
      if (!this.$compareObj(this.enableLists, this.originalEnableLists)) {
        this.isShowLoading = true
        this.setPoeSchedule(this.enableLists)
          .then((res) => {
            this.getConfig()
          })
      }
    },
    setDisabled: function (key) {
      if (key > 8) return true
      return false
    },
    getTips: function (key) {
      let tips = ''
      if (this.setDisabled(key)) {
        tips = this.$t('poe.notSup')
      }
      return tips
    },
    ...mapActions(['getPoeSchedule', 'getPoeScheduleEnable', 'setPoeSchedule']),
    ...mapMutations(['openModal', 'closeModal'])
  },
  computed: {
    ...mapState({
      isDataChanged: state => state.app.isDataChanged,
      portNumber: state => state.module.portNum
    })
  }
}
</script>

<style lang="scss" scoped>

.content-tab.poeschedule {
  position: relative;
  padding: 20px 15px;
  overflow: hidden !important;
  .content-body {
    .content-item {
      .content-item {
        margin: 0px 30px 10px 30px;
        >.port {
          background: #6370AF;
          box-shadow: 0 0 4px 0 rgba(0,0,0,0.10);
          border-radius: 15.5px;
          padding-left: 13px;
          color: #ffffff;
          .port-cell {
            display: inline-block;
            width: 22px;
            height: 22px;
            line-height: 22px;
            border-radius: 12px;
            background-color: #fff;
            color: #000000;
            margin: 4px 0px 4px 20px;
            text-align: center;
            &.selected {
              background-color: #F8FA4C;
            }
            &:hover {
              cursor: pointer;
            }
          }
        }
      }
      .group-table {
        height: calc(100% - 50px);
        margin-top: 0px;
        border-bottom: 1px #F1F1F1 solid;
        >.poe-schedule-table {
          width: inherit;
          .link-row {
            height: auto !important;
            .right .data {
              padding: 0px;
              height: auto !important;
              border-right: 1px solid #F1F1F1;
              &.name {
                margin: auto;
                vertical-align: middle;
                >div {
                  line-height: 20px;
                  text-align: center;
                }
                >.title {
                  color: #535B98;
                  font-weight: bold;
                }
              }
              &.timeline {
                margin: auto;
                vertical-align: middle;
              }
              .detail {
                border: 1px solid #979797;
                border-radius: 4px;
                height: 24px;
                line-height: 24px;
                margin: 4px;
                font-size: 13px;
                color: #2F2F2F;
                text-align: center;
                vertical-align: middle;
              }
              .edit {
                margin-left: 10px;
              }
            }
          }
          .right-header >.timeline {
            text-align: center;
          }
        }
      }
    }
    .content-body-footer {
      top: calc(100% - 50px);
    }
  }
  .scrollbar-body {
    height: calc(100% - 105px);
    .content-body {
      .content-item {
        position: relative;
        div.content-body-header {
          padding: 0px 0px 10px 20px;
        }
        .content-item {
          padding-left: 20px !important;
          margin-bottom: 10px;
          margin-left: 30px;
          .title {
            display: inline-block;
          }
          .power-watt {
            width: 78px;
          }
          .q-radio {
            margin-left: 20px;
          }
        }
      }
      .group-table {
        margin-right: 15px;
      }
      >.content-body-footer {
        top: calc(100% - 50px);
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/PoeSchedule.vue